/**
 * @fileoverview POST handler for the "/engagement/conversion_report/:report_id/cancel" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCancelConversionReportReportIdCacheKeys } from "../engagementCancelConversionReport/constants";
import type { PostEngagementCancelConversionReportProps } from "../engagementCancelConversionReport/types";

export const postEngagementCancelConversionReport = reactQueryMutationAdapter(
  engagementCancelConversionReportReportIdCacheKeys,
  (props: PostEngagementCancelConversionReportProps): Promise<void> => {
    return fetch(`/engagement/conversion_report/${props.reportId}/cancel`, "POST");
  }
);
